/*
 *   File : cookie.js
 *   Description : Shared access_token cookie helpers (set/remove with matching options)
 */

import Cookies from "js-cookie";

const TOKEN_KEY = "access_token";

function getCookieOptions() {
    const options = { path: "/" };

    // Only set Domain when it matches the current host (wrong domain = browser rejects cookie → login redirect fails)
    const configuredDomain = process.env.REACT_APP_DOMAIN;
    if (
        configuredDomain &&
        configuredDomain !== "localhost" &&
        window.location.hostname !== "localhost" &&
        window.location.hostname.endsWith(configuredDomain.replace(/^\./, ""))
    ) {
        options.domain = configuredDomain.startsWith(".")
            ? configuredDomain
            : configuredDomain;
    }

    if (window.location.protocol === "https:") {
        options.secure = true;
        options.sameSite = "Lax";
    }

    return options;
}

export function setAccessToken(token) {
    if (!token) return false;
    Cookies.set(TOKEN_KEY, token, getCookieOptions());
    // Fallback: host-only cookie if domain-scoped set failed
    if (!Cookies.get(TOKEN_KEY)) {
        const fallback = { path: "/" };
        if (window.location.protocol === "https:") {
            fallback.secure = true;
            fallback.sameSite = "Lax";
        }
        Cookies.set(TOKEN_KEY, token, fallback);
    }
    return Boolean(Cookies.get(TOKEN_KEY));
}

export function removeAccessToken() {
    Cookies.remove(TOKEN_KEY);
    Cookies.remove(TOKEN_KEY, { path: "/" });
    const options = getCookieOptions();
    Cookies.remove(TOKEN_KEY, options);
    // Also clear legacy wrong-domain cookies if any
    const configuredDomain = process.env.REACT_APP_DOMAIN;
    if (configuredDomain && configuredDomain !== "localhost") {
        Cookies.remove(TOKEN_KEY, { path: "/", domain: configuredDomain });
    }
}

export function getAccessToken() {
    return Cookies.get(TOKEN_KEY);
}
